export const truncateText = (text: string, min: number) => {
  if (text.length <= min) return text
  return `${text.slice(0, min - 1)}...`
}
